/**
 * Rules for when pallet packing is permitted.
 *
 * The backend returns `allowsPallet` and, when
 * false, a human-readable `palletNotAllowedReason` on the shipment detail
 * payload. The helpers below read those fields directly.
 */
export var isPalletPackingAllowed = function (shipmentData) {
    return Boolean(shipmentData === null || shipmentData === void 0 ? void 0 : shipmentData.allowsPallet);
};
export var PALLET_DISABLED_TOOLTIP_FALLBACK = 'Pallet packing is not allowed for this shipment.';
export var getPalletDisabledReason = function (shipmentData) {
    return (shipmentData === null || shipmentData === void 0 ? void 0 : shipmentData.palletNotAllowedReason) || PALLET_DISABLED_TOOLTIP_FALLBACK;
};
